import React from 'react'

type Props = {
  colSpan?: number
  backgroundColor?: string
  className?: string
  onClick?: any
  style?: React.CSSProperties
}

export const TD: React.FC<Props> = ({
  colSpan,
  backgroundColor,
  onClick,
  className,
  children,
  style,
}) => {
  return (
    <td
      className={`${backgroundColor} ${className}`}
      colSpan={colSpan != undefined ? colSpan : 1}
      onClick={onClick}
      style={style}
    >
      {children}
    </td>
  )
}
